import { computed, ref, watch } from 'vue'
import useOrdersOfService from '@/modules/OrderOfService.js'

const dropdown_orders_of_service = ref([])
const dropdown_order_of_service_filters = ref({
  name: '',
})
const loading = ref(false)

let lastPage = -1

export default function useOrdersOfServiceDropdown() {
  const perPage = 10

  const { orders_of_service, listOrdersOfService, order_of_service_filters } = useOrdersOfService()

  const loadNextOrdersOfServicePage = () => {
    const page = currentPage() + 1

    if (page === lastPage) return

    loading.value = true

    listOrdersOfService(currentPage() + 1, perPage).then(() => {
      loading.value = false

      const ordersOfServiceNotLoaded = [...orders_of_service.value]

      const ordersOfServiceList = [...dropdown_orders_of_service.value, ...ordersOfServiceNotLoaded]

      dropdown_orders_of_service.value = ordersOfServiceList

      lastPage = page
    })
  }

  const currentPage = () => {
    return Math.floor(dropdown_orders_of_service.value.length / perPage)
  }

  const onOrdersOfServiceDropdownScroll = (e) => {
    if (
      e.srcElement.offsetHeight + e.srcElement.scrollTop >=
      e.srcElement.scrollHeight
    ) {
      if (!loading.value) {
        loadNextOrdersOfServicePage()
      }
    }
  }

  const updateFilters = async () => {
    if (!loading.value) {
      order_of_service_filters.value = dropdown_order_of_service_filters.value
      dropdown_orders_of_service.value = []
      lastPage = -1

      loadNextOrdersOfServicePage()
    }
  }

  watch(dropdown_order_of_service_filters.value, () => {
    setTimeout(() => {
      updateFilters()
    }, 250)
  })

  return {
    dropdown_orders_of_service: computed(() => dropdown_orders_of_service.value),
    dropdown_order_of_service_filters: computed(() => dropdown_order_of_service_filters.value),
    loadNextOrdersOfServicePage,
    onOrdersOfServiceDropdownScroll,
  }
}
